import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const commandPaletteEvents = eventGroup({
  source: 'Command Palette',
  events: {
    openRequested: type<void>(),
  },
});
